import { Box } from '@mantine/core';
import { useReducedMotion } from '@mantine/hooks';
import type { CSSProperties } from 'react';
import classes from './MaskedSidebarVideo.module.css';

type Props = {
  opacity?: number;
  scaleX?: number;
};

export function MaskedSidebarVideo({ opacity, scaleX }: Props) {
  const reducedMotion = useReducedMotion(undefined, { getInitialValueInEffect: false });
  const style: CSSProperties = {};
  if (opacity !== undefined) style.opacity = opacity;
  if (scaleX !== undefined) style.transform = `scaleX(${scaleX})`;

  return (
    <Box className={classes.videoWrapper}>
      {reducedMotion ? (
        <img
          src="/sidebar-background-poster.webp"
          alt=""
          aria-hidden="true"
          className={classes.maskedMedia}
          style={Object.keys(style).length === 0 ? undefined : style}
        />
      ) : (
        <video
          autoPlay
          loop
          muted
          playsInline
          className={classes.maskedMedia}
          style={Object.keys(style).length === 0 ? undefined : style}
        >
          <source src="/sidebar-background.mp4" type="video/mp4" />
        </video>
      )}
    </Box>
  );
}
